import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDialogTitle } from '@facet-wealth/design';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { CodeSentText } from './Layout/CodeSentText';

const ChallengeSMSStepMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('remainingAttempts', { hidden: true })
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride('primaryText', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .nameOverride('sentTo', {
    _component: () => CodeSentText,
  }, overrideReadOnly);

export default ChallengeSMSStepMetaOverrideSet;
